import React, { useEffect, useState } from "react";
import { Table, Tag, Card, Empty, Image, Space, Input } from "antd";
import { GeneralService } from "../../../Services/GeneralService";
import TitleHead from "../../../components/Customs/TitleHead";
import { canViewModule } from "../../../../utils/permissionUtils";
import { ENDPOINTS } from "../../../Services/ENDPOINT";
import { PrinterOutlined } from "@ant-design/icons";
import CustomIcon from "../../../components/Customs/CustomIcon";

import pos from '../../../../assets/payment-terminal.png'
import printer from '../../../../assets/printing.png'
import generateA4PDF from "../../../components/Customs/generateA4PDF";
import generatePDF from "../../../components/Customs/generatePDF";
import { RoomServices } from "../../../Services/RoomServices";

const MODULE_KEY = "manage_customers";
const image_base_url = ENDPOINTS.cleanBase;

const ListAllCust = () => {

    const [customers, setCustomers] = useState([]);
    const [searchText, setSearchText] = useState("");

    //printing config
    const [headerImg, setHeaderImg] = useState('');
    const [headera4Img, setA4PdfHeaderImg] = useState('');
    const [footerImg, setFooterImg] = useState('');
    const [gst, setGst] = useState('');
    const [gstType, setGstType] = useState("exclusive");
    

    const parseDocuments = (documentUpload) => {
        if (!documentUpload) return [];

        try {
            if (Array.isArray(documentUpload)) return documentUpload;

            const parsed = JSON.parse(documentUpload);
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    };

    const getDocumentUrl = (path) =>
        path?.startsWith("http")
            ? path
            : `${ENDPOINTS.cleanBase.replace(/\/$/, "")}/${path?.replace(/^\/+/, "")}`;

    const getAllCust = async () => {
        try {
            const res = await GeneralService.get("book_room");

            const bookings = (res.data || []).filter(
                (item) =>
                    item.guest_name?.trim() ||
                    item.phone?.trim() ||
                    item.email?.trim()
            );

            const grouped = bookings.reduce((acc, booking) => {
                const key =
                    booking.phone?.trim() ||
                    booking.email?.trim() ||
                    booking.guest_name?.trim();

                if (!acc[key]) {
                    acc[key] = {
                        key,
                        guest_name: booking.guest_name,
                        phone: booking.phone,
                        id_type: booking.id_type,
                        id_number: booking.id_number,
                        email: booking.email,
                        address: booking.address,
                        bookings: [],
                    };
                }

                acc[key].bookings.push(booking);
                return acc;
            }, {});

            setCustomers(Object.values(grouped));
        } catch (err) {
            console.error(err);
        }
    };

    const getCheckTime = async () => {
        try {
            const req = await RoomServices.getAllByTable("utills");

            const checkInTime = req.data?.[0]?.checkin_time;
            const checkOutTime = req.data?.[0]?.checkout_time;


            setHeaderImg(req.data?.[0]?.header_img);
            setFooterImg(req.data?.[0]?.footer_img);
            setA4PdfHeaderImg(req.data?.[0]?.a4_pdf_header_img);

        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        getAllCust();
        getCheckTime();
    }, []);

    const bookingColumns = [
        {
            title: "Check In",
            dataIndex: "check_in",
        },
        {
            title: "Check Out",
            dataIndex: "check_out",
        },
        {
            title: "Mode",
            dataIndex: "mode",
            key: "mode",
            render: (mode) => (
                <Tag color={mode?.toLowerCase() === "online" ? "blue" : "purple"}>
                    {mode || "—"}
                </Tag>
            ),
        },
        {
            title: "Room",
            render: (_, row) => (
                <>
                    {row.room_name}
                    <br />
                    <small>Room No: {row.room_number}</small>
                </>
            ),
        },
        {
            title: "Room Type",
            dataIndex: "room_type",
        },
        {
            title: "Guests",
            dataIndex: "guests",
        },
        {
            title: "Paid",
            render: (_, row) => `₹${row.paid_amount || 0}`,
        },
        // {
        //     title: "Total",
        //     render: (_, row) => `₹${row.total_amount || 0}`,
        // },
        {
            title: "Payment",
            dataIndex: "payment_mode",
        },
        {
            title: "Status",
            dataIndex: "guest_status",
            render: (status) => {
                const colorMap = {
                    reserved: "orange",
                    occupied: "green",
                    check_out: "red",
                    available: "blue",
                    cancel: "volcano",
                };

                return (
                    <Tag color={colorMap[status] || "default"}>
                        {status?.toUpperCase() || "—"}
                    </Tag>
                );
            },
        },

        {
            title: "Re-Print Bill",
            key: "reprint",
            align: "center",
            render: (_, record) => {
                const pricing_summary =
                    typeof record.pricing_summary === "string"
                        ? JSON.parse(record.pricing_summary || "{}")
                        : record.pricing_summary || {};

                const room = {
                    ...record,
                    id: record.room_id,
                    price_per_hour: record.price_per_hour,
                };

                const bookId = record.id;
                const nights = Number(record.duration_nights || pricing_summary.duration_nights || 0);
                const totalPayable = Number(record.total_amount || pricing_summary.total_amount || 0);
                const paid = Number(record.paid_amount || pricing_summary.paid_amount || 0);
                const advance = Number(pricing_summary.received_advance || 0);
                const remaining = Number(pricing_summary.remaining_payable || 0);
                const discount = Number(pricing_summary.discount_amount || 0);

                const gst = pricing_summary.customer_gst || record.customer_gst || "";
                const gstPercent = Number(pricing_summary.gst_percent || 0);
                const gstAmount = Number(pricing_summary.gst_amount || 0);
                const gstType = pricing_summary.gst_type;

                const hourlyBook = pricing_summary.booking_type === "hourly";
                const totalHours = Number(pricing_summary.duration_hours || 0);

                const finalStatus = pricing_summary.payment_status || record.payment_status || "";
                const finalAmountType = pricing_summary.amount_type || null;

                const isDiscount = discount > 0;
                const isAdvance = advance > 0;

                return (
                    <Space>
                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                console.log("A4 Print Record:", record);

                                generateA4PDF({
                                    form: record.raw_data || record,
                                    bookIds: [bookId],
                                    rooms: [room],
                                    nights,
                                    grandTotal: totalPayable,
                                    paidAmount: paid,
                                    receivedAdvance: advance,
                                    remainingPayable: remaining,
                                    discountAmount: discount,
                                    amountType: isDiscount ? "discount" : isAdvance ? "advance" : finalAmountType,
                                    paymentStatus: finalStatus,
                                    pricing_summary,
                                    loyaltyDiscountPercent: pricing_summary.loyalty_discount_percent || 0,
                                    loyaltyDiscountAmount: pricing_summary.loyalty_discount_amount || 0,
                                    gst,
                                    gstType,
                                    gstPercent,
                                    gstAmount,
                                    // headera4Img,
                                    // footerImg,
                                    headera4Img: `${ENDPOINTS.IMG_HEADER}${headera4Img}`,
                                    footerImg: `${ENDPOINTS.IMG_HEADER}${footerImg}`,

                                    hourlyBook,
                                    totalHours,
                                    bookingType: hourlyBook ? "hourly" : "Day",
                                    ratePerHour: room.price_per_hour,
                                    overdue_amount: pricing_summary?.overdue_amount || 0,
                                    early_checkin_amount: pricing_summary?.early_checkin_amount || 0,
                                    overdue_duration: pricing_summary?.overdue_duration || "",
                                    finalRemainingPayable: remaining,
                                });
                            }}
                        >
                            <CustomIcon image={printer} />
                        </span>

                        <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                                console.log("POS Print Record:", record);

                                generatePDF({
                                    showUnitName: true,
                                    form: record.raw_data || record,
                                    bookId,
                                    bookIds: [bookId],
                                    rooms: [room],
                                    nights,
                                    total: totalPayable,
                                    grandTotal: totalPayable,
                                    paidAmount: paid,
                                    receivedAdvance: advance,
                                    remainingPayable: remaining,
                                    discountAmount: discount,
                                    amountType: isDiscount ? "discount" : isAdvance ? "advance" : finalAmountType,
                                    paymentStatus: finalStatus,
                                    pricing_summary,
                                    loyaltyDiscountPercent: pricing_summary.loyalty_discount_percent || 0,
                                    loyaltyDiscountAmount: pricing_summary.loyalty_discount_amount || 0,
                                    gst,
                                    gstType,
                                    gstPercent,
                                    gstAmount,
                                    headerImg: `${ENDPOINTS.IMG_HEADER}${headerImg}`,
                                    footerImg: `${ENDPOINTS.IMG_HEADER}${footerImg}`,
                                    hourlyBook,
                                    totalHours,
                                    bookingType: hourlyBook ? "hourly" : "Day",
                                    ratePerHour: room.price_per_hour,
                                    overdue_amount: pricing_summary?.overdue_amount || 0,
                                    early_checkin_amount: pricing_summary?.early_checkin_amount || 0,
                                    overdue_duration: pricing_summary?.overdue_duration || "",
                                    full_book: record.full_book,
                                    isHistory: true,
                                });
                            }}
                        >
                            <CustomIcon image={pos} />
                        </span>
                    </Space>
                );
            },
        }
    ];

    const customerColumns = [
        {
            title: "S.No.",
            width: 70,
            render: (_, __, index) => index + 1,
        },
        {
            title: "Guest Name",
            dataIndex: "guest_name",
        },
        {
            title: "Phone",
            dataIndex: "phone",
        },
        {
            title: "ID Type",
            dataIndex: "id_type",
        },
        {
            title: "ID Number",
            dataIndex: "id_number",
        },
        {
            title: "Total Visits",
            align: "center",
            render: (_, row) => row.bookings.length,
        },
        {
            title: "Last Stay",
            render: (_, row) =>
                [...row.bookings].sort(
                    (a, b) => new Date(b.check_in) - new Date(a.check_in)
                )[0]?.check_in || "—",
        },
    ];

    const getFileType = (url = "") => {
        const ext = url.split(".").pop()?.toLowerCase();

        if (["jpg", "jpeg", "png", "webp", "gif", "bmp"].includes(ext)) return "image";
        if (ext === "pdf") return "pdf";

        return "file";
    };

    const filteredCustomers = customers.filter((customer) => {
        const search = searchText.toLowerCase();

        return (
            customer.guest_name?.toLowerCase().includes(search) ||
            customer.phone?.toLowerCase().includes(search) ||
            customer.email?.toLowerCase().includes(search) ||
            customer.id_number?.toLowerCase().includes(search) ||
            customer.id_type?.toLowerCase().includes(search) ||
            customer.address?.toLowerCase().includes(search) ||
            customer.bookings?.some((booking) =>
                [
                    booking.room_name,
                    booking.room_number,
                    booking.room_type,
                    booking.check_in,
                    booking.check_out,
                    booking.mode,
                    booking.payment_mode,
                    booking.guest_status,
                ]
                    .join(" ")
                    .toLowerCase()
                    .includes(search)
            )
        );
    });


    const renderDocuments = (bookings = []) => {
        const documents = bookings.flatMap((booking) =>
            parseDocuments(booking.document_upload)
        );

        if (!documents.length) return (
            <Card title="Uploaded Documents">
                <Empty description="Document Not Uploaded!" />
            </Card>
        )



        return (
            <div style={{ marginBottom: 12 }}>
                <Card title="Uploaded Documents">

                    <Image.PreviewGroup>
                        <Space wrap style={{ marginTop: 8 }}>
                            {documents.map((doc, index) => {
                                const url = getDocumentUrl(doc);
                                const type = getFileType(url);

                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: 120,
                                            border: "1px solid #ddd",
                                            borderRadius: 8,
                                            padding: 8,
                                            textAlign: "center",
                                        }}
                                    >
                                        {type === "image" && (
                                            <Image
                                                src={url}
                                                width={100}
                                                height={70}
                                                style={{
                                                    objectFit: "cover",
                                                    borderRadius: 6,
                                                }}
                                                preview={{
                                                    mask: `View Document ${index + 1}`,
                                                }}
                                                alt={`Document ${index + 1}`}
                                            />
                                        )}

                                        {type === "pdf" && (
                                            <a href={url} target="_blank" rel="noreferrer">
                                                <div
                                                    style={{
                                                        height: 70,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        background: "#fff1f0",
                                                        borderRadius: 6,
                                                        fontWeight: 700,
                                                        color: "#cf1322",
                                                    }}
                                                >
                                                    PDF
                                                </div>
                                                <div style={{ marginTop: 6, fontSize: 12 }}>View PDF</div>
                                            </a>
                                        )}

                                        {type === "file" && (
                                            <a href={url} target="_blank" rel="noreferrer">
                                                <div
                                                    style={{
                                                        height: 70,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        background: "#f0f5ff",
                                                        borderRadius: 6,
                                                        fontWeight: 700,
                                                        color: "#1d39c4",
                                                    }}
                                                >
                                                    FILE
                                                </div>
                                                <div style={{ marginTop: 6, fontSize: 12 }}>Open File</div>
                                            </a>
                                        )}
                                    </div>
                                );
                            })}
                        </Space>
                    </Image.PreviewGroup>
                </Card>
            </div>
        );
    };

    if (!canViewModule(MODULE_KEY)) {
        return <Empty description="No permission to view this page" />;
    }

    return (
        <Card
            title={
                <TitleHead
                    h1="Manage Customer Records"
                    h2="View guest profiles, booking history, stay details, payments, and reservation activity."
                />
            }

            extra={
                <Input.Search
                    placeholder="Search customer, phone, email, room..."
                    allowClear
                    size="large"
                    onChange={(e) => setSearchText(e.target.value)}
                    style={{ width: 370 }}
                />
            }
        >
            <Table
                rowKey="key"
                columns={customerColumns}
                dataSource={filteredCustomers}
                expandable={{
                    expandedRowRender: (record) => (
                        <>
                            {renderDocuments(record.bookings)}
                            <Table
                                rowKey="id"
                                columns={bookingColumns}
                                dataSource={record.bookings}
                                pagination={false}
                                size="small"
                                scroll={{ x: "max-content" }}
                            />
                        </>
                    ),
                }}
            />
        </Card>
    );
};

export default ListAllCust;